<template>
  <v-container class="landing-page fill-height">
    <v-row align="center" justify="center">
      <!-- Title Section -->
      <v-col cols="12" class="text-center mb-12">
        <h1 class="text-h2 font-weight-bold mb-4">Welcome to SunShadow</h1>
        <p class="text-h6 text-medium-emphasis">
          Protect your skin with real-time UV monitoring and personalized sun protection advice
        </p>
      </v-col>

      <!-- Feature Cards Section -->
      <v-col cols="12">
        <v-row justify="center">
          <v-col v-for="feature in features" 
                 :key="feature.title" 
                 cols="12" md="5"
                 class="px-6 mb-8">
            <v-card 
              class="feature-card mx-auto d-flex flex-column" 
              elevation="0"
              rounded="lg"
              width="100%"
            >
              <div class="feature-icon-wrapper">
                <v-icon 
                  :color="feature.color" 
                  size="48"
                  class="feature-icon"
                >
                  {{ feature.icon }}
                </v-icon>
              </div>
              <v-card-item class="flex-grow-1 d-flex flex-column">
                <v-card-title class="text-center pt-2 font-weight-bold text-h5">
                  {{ feature.title }}
                </v-card-title>
                <v-card-text class="text-center text-body-1 text-medium-emphasis flex-grow-1 d-flex align-center justify-center">
                  {{ feature.description }}
                </v-card-text>
              </v-card-item>
              <v-card-actions class="justify-center pb-6">
                <v-btn
                  :to="feature.path"
                  :color="feature.color"
                  variant="outlined"
                  class="px-8 py-2"
                  rounded="pill"
                  size="large"
                >
                  Learn More
                  <v-icon end class="ml-2">mdi-arrow-right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LandingView',
  data() {
    return {
      features: [
        {
          title: 'Real-time UV Index Monitoring',
          description: 'Help users understand current sunlight intensity and track sun protection timing',
          icon: 'mdi-white-balance-sunny',
          color: 'amber-darken-2',
          path: '/uvindex'
        },
        {
          title: 'Personalized Sunscreen Tips',
          description: 'Get customized sunscreen recommendations based on UV index and skin type',
          icon: 'mdi-bottle-tonic',
          color: 'teal-darken-1',
          path: '/personal'
        },
        {
          title: 'Sun-Safe Clothing Guide',
          description: 'Recommend suitable protective clothing for different UV levels',
          icon: 'mdi-tshirt-crew',
          color: 'blue-darken-1',
          path: '/clothing'
        },
        {
          title: 'Smart Sunscreen Reminders',
          description: 'Receive timely notifications to reapply sunscreen throughout the day',
          icon: 'mdi-bell-ring',
          color: 'deep-orange',
          path: '/reminder'
        }
      ]
    }
  }
}
</script>

<style scoped>
.landing-page {
  background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
  min-height: 100vh;
  padding: 40px 0;
}

.feature-card {
  min-height: 400px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  padding: 30px 20px;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.1) !important;
  background: rgba(255, 255, 255, 1) !important;
}

.feature-icon-wrapper {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 24px;
}

.feature-icon {
  transform: scale(1);
  transition: transform 0.3s ease;
}

.feature-card:hover .feature-icon {
  transform: scale(1.1);
}

.v-card-title {
  font-size: 1.5rem !important;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.87);
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}

.v-card-text {
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.6;
  padding: 20px;
  font-size: 1.1rem !important;
  min-height: 120px;
}

.v-btn {
  text-transform: none !important;
  letter-spacing: 0.5px;
  font-weight: 500;
  font-size: 1.1rem;
}

.v-btn:hover {
  transform: translateX(5px);
  transition: transform 0.3s ease;
}

@media (max-width: 959px) {
  .feature-card {
    min-height: 350px;
  }
  
  .v-card-text {
    min-height: 100px;
  }
}
</style> 